import it_core from "./it.js";
import it_extra from "./it_extra.js";
import en_core from "./en.js";
import en_extra from "./en_extra.js";

const it = { ...it_core, ...it_extra };
const en = { ...en_core, ...en_extra };

const CATALOGS = { it, en };

function lookup(catalog, path) {
  return path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), catalog);
}

export function makeTranslator(lang) {
  const safe = CATALOGS[lang] || CATALOGS.it;
  return function t(key, vars) {
    let value = lookup(safe, key);
    if (value === undefined) value = lookup(CATALOGS.it, key);
    if (value === undefined) return key;
    if (typeof value === "string" && vars) {
      for (const k of Object.keys(vars)) {
        value = value.replace(new RegExp(`{{\\s*${k}\\s*}}`, "g"), String(vars[k]));
      }
    }
    return value;
  };
}

export const SUPPORTED_LANGS = ["it", "en"];
export default CATALOGS;
